<template>
  <div class="modal_wrap app_download_modal" :class="{ on: isOpen }">
    <!--'on 추가'-->
    <div class="modal_inner">
      <div class="modal">
        <div class="web_app_btn">
          <div class="web_btn pnt" @click="close('WEB')">웹으로 보기 ></div>
          <div class="app_btn pnt" @click="close('APP')">앱 다운로드하기 ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppDownloadModal',
  props: {
    isOpen: Boolean,
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    close(sel) {
      this.$emit('close', sel);
    },
  },
};
</script>
